<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ApproveInspDataForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApproveInspDataForm from '@/components/organisms/terminal/form/ApproveInspDataForm'

export default {
  name: 'ApproveInspDataPage',

  components: {
    ApproveInspDataForm,
  },
}
</script>
